export default __webpack_public_path__ + "static/scznyyMb-dd3d6b99cee21658d49d302940eaf1cc.png";